import { useCallback, useEffect, useState } from "react";
import { HttpMethod, initFetch } from "../utils/fetcher";

const useRecapLots = (year, month) => {
  const [data, setData] = useState({ lots: [], years: [], number: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLots = useCallback(async (signal) => {
    setLoading(true);
    setError(null);

    try {
      const { url, params } = initFetch(`recap-lots?year=${year}&month=${month}`, HttpMethod.GET);
      const response = await fetch(url, { ...params, signal });

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${result.message}`);
      }

      setData({
        lots: result.lots,
        number: result.number,
        years: result.years,
      });
    } catch (e) {
      // On ignore l'erreur déclenchée par l'annulation volontaire
      if (e.name === "AbortError") return;
      setError(e.message);
    } finally {
      // On ne touche au loading que si la requête n'a pas été annulée
      if (!signal?.aborted) {
        setLoading(false);
      }
    }
  }, [year, month]);

  useEffect(() => {
    const controller = new AbortController();
    fetchLots(controller.signal).then();

    return () => controller.abort();
  }, [fetchLots]);

  // refetch manuel : crée son propre controller
  const refetch = useCallback(() => {
    const controller = new AbortController();
    fetchLots(controller.signal).then();
    return () => controller.abort();
  }, [fetchLots]);

  return {
    lots: data.lots,
    number: data.number,
    years: data.years,
    loading,
    error,
    refetch,
  };
};

export default useRecapLots;